<template>
    <div class="overflow-hidden-x">
        <div class="row g-0">
            <div class="col-lg-12">
                <div class="container-fluid">
                    <h6
                        v-if="!hideBackToSearch"
                        class="goto-search cursor-pointer d-inline-flex align-items-center gap-2"
                        title="Go Back"
                        @click.prevent="goBack"
                    >
                        <i class="fas fa-arrow-left search-layout-back-icon" aria-hidden="true"></i>
                        
                    </h6>
                </div>
            </div>
        </div>
        <provider-profile
            :consumerId="consumerId"
            :providerEntityId="providerEntityId"
            :showPanelTitle="true"
            @profile-ready="onProfileReady"
        />
        <!-- <div class="ac-panel-title">
            Plans
        </div> -->
        <div style="margin-top: .5rem;">
            <plan-stack-skeleton v-if="!showPlansSection" />
            <plans
                v-if="showPlansSection"
                :plans="filteredPlans"
                :hidePlanPrice="!isProviderAcceptingNewPatients"
            />
        </div>
    </div>
</template>

<script>
    import ProviderProfile from "../../../../components/shared/providerProfileAndPlans/ProviderProfile.vue";
    import {physcianPlansMixin} from "../../../../components/shared/mixins/physicianPlansMixin.js";
    import {mapGetters} from "vuex";
    import {common} from "../../../../global/common.js";
    import Plans from "../../../../components/shared/providerProfileAndPlans/Plans.vue";
    import PlanStackSkeleton from "../../../../components/shared/providerProfileAndPlans/PlanStackSkeleton.vue";
    import PlanSelection from "./PlanSelection.vue";
    import Plan from "../../../../components/shared/providers/plans/Plan.vue";
    import {planCategoryFilterMixin} from "../../../../components/shared/mixins/planCategoryFilterMixin.js";

    export default {
        name: "ProviderProfileLayout",
        props: {
            providerEntityId: {type: [Number], required: true},
            consumerId: {type: [Number], required: true},
            hideBackToSearch: {type: Boolean, default: false},
            planCategoryId: {type: [Number, String], default: null}
        },
        components: {Plan, PlanSelection, Plans, PlanStackSkeleton, ProviderProfile},
        data() {
            return {
                plansDataReady: false,
                profileReady: false,
            };
        },
        mixins: [physcianPlansMixin, planCategoryFilterMixin],
        computed: {
            ...mapGetters(["familyMembersPlanInfo"]),
            ...mapGetters({showPricing: "globalSettings/showPricing"}),
            filteredPlans() {
                return this.filterPlansByCategory(this.plans);
            },
            showPlansSection() {
                return this.plansDataReady && this.profileReady;
            },
        },
        watch: {
            showPlansSection(val) {
                if (val) {
                    this.$nextTick(() => this.addSlimScroll());
                }
            },
        },
        methods: {
            goBack() {
                common.goBack();
            },
            getCustomId(planName, planId) {
                let id = "";
                id = planName + "select" + planId;
                id = "p-" + id.replace(/\W/g, '-').toLowerCase();
                return id;
            },
            onProfileReady() {
                this.profileReady = true;
            },
        },
        async mounted() {
            let url = `Shared/getProviderPlansForConsumer/${this.providerEntityId}/${this.consumerId}`;
            await this.baseInit(url, { deferSlimScroll: true });
            this.plansDataReady = true;
        }

    }
</script>

<style scoped>
    /* Match SearchLayout.vue back link (success green; !important beats heading + FA overrides) */
    .goto-search {
        text-transform: none;
        font-weight: 400;
        color: var(--bs-success, #198754) !important;
        margin-top: 0.5rem;
    }

    .search-layout-back-icon {
        font-size: 1.75rem;
        line-height: 1;
        color: #343a40 !important;
    }

    .background-white {
        background: #FFFFFF;
    }

    .profile-body {
        padding-right: 0;
    }

    .profile-body .select-button {
        margin-top: 10px;
    }

    .overflow-hidden-x {
        overflow-x: hidden;
    }

</style>